<vitamui-dialog-header [subhead]="dialogSubTitle()" [title]="dialogTitle()"></vitamui-dialog-header>

<mat-dialog-content>
  <ng-content></ng-content>
</mat-dialog-content>

<mat-dialog-actions>
  <button class="btn primary" [matDialogClose]="true" cdkFocusInitial>
    <ng-container>{{ confirmLabel() ? confirmLabel() : ('COMMON.CONFIRM' | translate) }}</ng-container>
  </button>
  <button class="btn link cancel" [matDialogClose]="false">
    <ng-container>{{ cancelLabel() ? cancelLabel() : ('COMMON.BACK' | translate) }}</ng-container>
  </button>
</mat-dialog-actions>
